export default __webpack_public_path__ + "static/media/LoginImage.92ec4ae8.jpeg";